<template>
	<div class="content">
		<h3>数码详细查询</h3>
		<div class="item">
			<el-form ref="form" :inline="true" style="width:800px" :model="form" label-width="80px">        
				<el-form-item label="数码" style="width:800px">
					<el-input v-model="form.Odd"  clearble></el-input>
				</el-form-item> 
                <el-form-item label="待查数码" >
					
				</el-form-item> 
			</el-form>
			<div class="btn">
				<el-button type="primary">查 询</el-button>
                <el-button type="warning">重 置</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" prop="OrderCode" label="订单"></el-table-column>
				<el-table-column align="center" prop="Code" label="操作数码"></el-table-column>
				<el-table-column align="center" prop="ProductCode" label="产品编码"></el-table-column>
                <el-table-column align="center" prop="ProductName" label="产品名称"></el-table-column>
				<el-table-column align="center" prop="Package" label="包装层级"></el-table-column>
				<el-table-column align="center" prop="Unit" label="包装单位"></el-table-column>
			</el-table>
            <el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form: {
				Odd: null
			},
			pageNum:0,
			tableData: []
		}
	},
	methods: {
		SelSingCodeTrace(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//数码详细查询
			this.$axios({
        		method: 'post',
        		url:'/FW/ViewCodeDetail.ashx',
        		params: {
					action:"ViewOutCodeDetail",
          			qry: this.form,
					cid:user.QyNum
        		}
        	}).then(res=>{
          		if(res.Code==0){
					console.log(res);
					this.tableData=res.Data.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})
		}
	}
}
</script>

<style scoped>
.btn{
	width: 500px;
	margin:0 80px;
}
.el-form--inline .el-form-item{
    width:300px;
    margin-bottom: 10px;
}
.el-input,.el-select {
	width:200px;
}
</style>


// WEBPACK FOOTER //
// src/pages/singCodeTrace.vue